<template>
    <div class="form-group--border">
        <h4>Параметры поиска</h4>
            <div class="row d-flex flex-wrap my-3">
              <div class="col-12 col-md-4">
                <div class="form-group required">
                  <component-input label="Фамилия"
                                  placeholder="Введите фамилию"
                                  required
                                  v-model="surname"/>
                </div>
                </div>
                  <div class="col-12 col-md-4">
                      <div class="form-group">
                          <component-input label="Имя"
                                           placeholder="Введите имя"
                                           v-model="name"/>
                      </div>
                  </div>
                  <div class="col-12 col-md-4">
                      <div class="form-group">
                          <component-input label="Отчество"
                                           placeholder="Введите отчество"
                                           v-model="middlename"/>
                      </div>

              </div>

            </div>

            <div class="row my-3">
              <div class="col">
                <div class="form-group required">
                  <label class='control-label required'>Дата рождения</label>
                  <div>
                      <date-component  v-model="dateOfBirth" required/>
                  </div>
                </div>

                              
              </div>
                <div class="col">
                    <div class="form-group">
                        <component-input label="СНИЛС"
                                         type="snils"
                                         placeholder="Введите снилс"
                                         v-model="snils"/>
                    </div>
                </div>

            </div>
            <div v-if="found" class="form-group--border">
              <h4>Результаты поиска</h4>
              <template v-if="found.length">
                <div class="table-inner">
                  <table class="table-custom">
                    <thead>
                      <tr>
                        <th class="col-table-1">Импорт</th>
                        <th class="col-table-3">Фамилия</th>
                        <th class="col-table-3">Имя</th>
                        <th class="col-table-3">Отчество</th>
                        <th class="col-table-3">Дата рождения</th>
                        <th class="col-table-2">СНИЛС</th>
                        <th class="col-table-3">Полис</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in found" :key="item.id">
                        <td class="table-action-cell text-center">
                          <button class="btn shadow-none"><i class="fas fa-cloud-download-alt" v-on:click="importPerson(item)"/></button>
                        </td>
                        <td>{{ item.personSurName_SurName }}</td>
                        <td>{{ item.personFirName_FirName }}</td>
                        <td>{{ item.personSecName_SecName }}</td>
                        <td>{{ item.personBirthDay_BirthDay }}</td>
                        <td>{{ item.personSnils_Snils }}</td>
                        <td>{{ item.polis_Ser ? item.polis_Ser + ' ' : ''  }}{{item.polis_Num}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <template v-else>
                <EmptyListMessage/>
              </template>      
            </div>

            <div>
              <div class="float-right d-flex align-items-center mt-4">
                <button-component class="btn btn-primary mx-2" :disabled="inSearch" v-on:click="find">
                  <span v-if="inSearch" class="pr-1"><i class="fa fa-spinner fa-spin"></i></span>
                  Найти</button-component>
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
              </div>
            </div>
    </div>

</template>
<script>
import API from '../api/ras'
import Constants from '../../../common/constants'
import { useVuelidate } from '@vuelidate/core'
  import DateComponent from "@/common/components/DateComponent"
  import ComponentInput from "@/common/components/ComponentInput";
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "ImportPatient",
  components: {
      ButtonComponent,
    ComponentInput,
    DateComponent,
  },  
  props: {
  },
  created() {
  },
  mounted() {
  },
  emits: ['close'],
  data() {
    return {
        surname: '',
        name: '',
        middle: '',
        dateOfBirth: null,
        snils: '',
        found: null,

        inSearch: false
    };
  },
  methods: {
    close() {
        this.$emit('close');
    },
    find() {
        var self = this;

        self.v$.$touch();
        if (self.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Заполните обязательные поля', 'error' );
          return;
        }
        var params = {
          surname: this.surname,
          name: this.name,
          middle: this.middle,
          snils: this.snils,
          dt: this.dateOfBirth
        }

        this.inSearch = true;
        API.findPersonsRMIS(params).then(response => {
            this.found = response.data.data;
            console.log(this.found);
            this.inSearch = false;
            if(response.data.error_msg) {
              Constants.alert.fire('Ошибка', response.data.error_msg, 'error');
            }
        })
        .catch(function() {
          Constants.alert.fire('Ошибка', 'Ошибка при поиске.', 'error');
          this.inSearch = false;
        });
    }, 
    importPerson(item)  {
        var params = {
          id: item.person_id,
          surname: item.personSurName_SurName,
          name: item.personFirName_FirName,
          middle: item.personSecName_SecName,
          dt: item.personBirthDay_BirthDay
        }
        API.importPersonRMIS(params).then(response => {
            console.log(response.data);
            if (response.data.success){
              const newid = response.data.message;
              this.$emit('close');
              this.$router.push({name: 'patientCard', params: {id: newid, action: 'edit'}})
            }
            else {
                Constants.alert.fire('Импорт', response.data.message, 'error');
            }
        });
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
    }
  }
}; 
</script>
<style lang="scss" scoped>

h4{
    font-size: 16px;
    font-weight: 600;
}
.form-check.required .control-label:after {
  content: "*";
  color: red;
}
.form-group.required .control-label:after {
  content: "*";
  color: red;
}

</style>
